import { ts } from '_core';

import { getName, validate } from './helpers';
import { DraftParams } from './types';

export default [
  {
    key: ts.enums.REPORT_ENUMS.WIDGET_KEY_ENUM.SIGNAL_BUCKETED_EVENT_STUDY,
    title: 'Bucketed Event Study',
    helpLabel: 'zok2e2k4',
    form: true,
    defaultParams: {
      days_before_event: 10,
      days_after_event: 21,
      format_for_ui: true,
    } as DraftParams,
    neededFiles: ['signal_event_study', 'signal_event_study_count'],
    tags: [
      ts.enums.REPORT_ENUMS.REPORT_TAG_ENUM.SIGNAL,
      ts.enums.REPORT_ENUMS.REPORT_TAG_ENUM.ALPHA_MODEL,
      ts.enums.REPORT_ENUMS.REPORT_TAG_ENUM.COMMON_ALPHA_MODEL,
    ],

    getName: getName,
    validate: validate,
  },
] satisfies ts.types.analysis.WidgetConfig[];
